// **********************************************************
// Fact Bubbles Module
// **********************************************************

const factBubblesImageSlider = document.querySelectorAll('[data-slider="fact-bubbles-image-slider"]');
const factBubblesTextSlider = document.querySelectorAll('[data-slider="fact-bubbles-text-slider"]');
const factBubblesThumbSlider = document.querySelectorAll('[data-slider="fact-bubbles-thumb-slider"]');
const factBubblesFakeSlider = document.querySelectorAll('[data-slider="fact-bubbles-fake-slider"]');

// Thumb Slider
const factBubblesThumbSliderOptions = {
  slidesPerView: 2.5,
  speed: 600,
  direction: 'horizontal',
  spaceBetween: 20,
  mousewheel: false,
  breakpoints: {
    767: {
      slidesPerView: 4.5,
    },
    1023: {
      slidesPerView: 4,
      spaceBetween: 25,
      direction: 'vertical',
    },
    1199: {
      slidesPerView: 4,
      spaceBetween: 40,
      direction: 'vertical',
    },
  },
};

factBubblesThumbSlider.forEach((el) => new Swiper(el, factBubblesThumbSliderOptions));

// Image Slider
const factBubblesImageSliderOptions = {
  slidesPerView: 1,
  speed: 600,
  direction: 'vertical',
  effect: 'creative',
  creativeEffect: {
    limitProgress: 2,
    prev: {
      translate: ['8%', '-102%', 0],
    },
    next: {
      translate: ['8%', '102%', 0],
    },
  },
  thumbs: {
    swiper: false,
  },
};

// Fake Slider
const factBubblesFakeSliderOptions = {
  slidesPerView: 1,
  speed: 600,
  mousewheel: {
    thresholdTime: 1000,
  },
  thumbs: {
    swiper: false,
  },
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
  },
};

factBubblesFakeSlider.forEach((el, i) => {
  factBubblesFakeSliderOptions.thumbs.swiper = factBubblesThumbSlider[i].swiper;
  const fakeSlider = new Swiper(el, factBubblesFakeSliderOptions);

  const updateSlider = () => {
    const isFirstSlide = fakeSlider.isBeginning;
    const isLastSlide = fakeSlider.isEnd;

    if (isFirstSlide || isLastSlide) {
      fakeSlider.params.mousewheel.releaseOnEdges = false;
      setTimeout(() => {
        fakeSlider.params.mousewheel.releaseOnEdges = true;
      }, 1000);
    }
  };

  updateSlider();

  fakeSlider.on('slideChange', updateSlider);
});

// Text Slider
const factBubblesTextSliderOptions = {
  slidesPerView: 1,
  speed: 600,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
};

factBubblesTextSlider.forEach((el, i) => {
  factBubblesTextSliderOptions.thumbs.swiper = factBubblesThumbSlider[i].swiper;
  new Swiper(el, factBubblesTextSliderOptions);
});

factBubblesImageSlider.forEach((el, i) => {
  const factBubbles = el.closest('.fact-bubbles-module');

  const textSliderElement = factBubbles.querySelector('[data-slider="fact-bubbles-text-slider"]');
  const thumbSliderElement = factBubbles.querySelector('[data-slider="fact-bubbles-thumb-slider"]');
  const fakeSliderElement = factBubbles.querySelector('[data-slider="fact-bubbles-fake-slider"]');
  const textSlider = textSliderElement.swiper;
  const thumbSlider = thumbSliderElement.swiper;
  const fakeSlider = fakeSliderElement.swiper;
  const imageSlider = new Swiper(el, factBubblesImageSliderOptions);

  fakeSlider.controller.control = [thumbSlider, textSlider, imageSlider];

  factBubblesImageSliderOptions.thumbs.swiper = factBubblesThumbSlider[i].swiper;
  new Swiper(el, factBubblesImageSliderOptions);
});
